/**============================================================
*   [Class] Service：ワークフローセクションスライダー
============================================================*/
export default class ServiceWorkflowSlider {
  constructor(
    target,
    key,
    targetClass
  )
  {
    //main slide
    this.swiperSlide = document.querySelector(`${targetClass} .p-service-workflow-slider__main`);
    this.swiperSlideItem = document.querySelectorAll(`${targetClass} .p-service-workflow-slider__main .swiper-slide`);
    this.swiperSlideItemNum = this.swiperSlideItem.length * 3;

    //thumb slide
    this.swiperThumbSlide = document.querySelector(`${targetClass} .p-service-workflow-slider__thumb`);
    this.swiperThumbSlideItem = document.querySelectorAll(`${targetClass} .p-service-workflow-slider__thumb__item`);

    this.swiperKey = key;
    this.swiperSlide.classList.remove('swiper-disabled');
    this.swiperSlide.classList.add('swiper-'+ this.swiperKey);

    //サムネイルスライド
    const switchThumb = (index) => {
      document.querySelector(`${targetClass} .thumb-is-active`).classList.remove('thumb-is-active');
      this.swiperThumbSlideItem[index].classList.add('thumb-is-active');
    }

    //メインスライド
    new Swiper(this.swiperSlide, {
      slidesPerView: 1,
      speed: 500,
      autoHeight: true,
      navigation: {
        nextEl: '.p-service-workflow-slider__main .p-service-workflow-slider__main__buttons .swiper-button-next',
        prevEl: '.p-service-workflow-slider__main .p-service-workflow-slider__main__buttons .swiper-button-prev',
      },
      on: {
        afterInit: (swiper) => {
          this.swiperThumbSlideItem[swiper.realIndex].classList.add('thumb-is-active');
          for (let i = 0; i < this.swiperThumbSlideItem.length; i++) {
            this.swiperThumbSlideItem[i].onclick = () => {
              swiper.slideTo(i);
            };
          }
        },
        slideChange: (swiper) => {
          switchThumb(swiper.realIndex);
        },
      }
    });
  }
}
